import { get } from 'http';

export const AppPaths = {
  // Base & Auth
  root: '/',
  empty: '',
  login: 'login',
  home: 'home',
  signUp: 'sign-up',
  manageUser: 'manage-user',

  // Help Desk
  helpdesk: 'help-desk',
  approveTicket: 'approve-ticket',
  attendTicket: 'attend-ticket',
  createTicket: 'create-ticket',
  myTickets: 'my-tickets',
  checkTickets: 'check-tickets',

  // External Links
  expenseAccountability: 'expense-accountability',
  kronos: 'https://prodac.scmlatam-cloud.com/wfc/htmlnavigator/logon',
  yourReceipt: 'https://$REPLACE.turecibo.com/e/login',
  performanceAssessment: 'https://$REPLACE.manduhr.com/login',

  // Modules
  events: 'events',
  loans: 'loans',
  contacts: 'contacts',
  recordScheduledVisits: 'record-scheduled-visits',
  scheduledVisits: 'list-scheduled-visits',

  // Manufacturing - Requests
  manufacturingRoutes: 'manufacturing-routes',
  indicators: 'indicators',
  requests: 'requests',
  requestsSumary: 'requests-sumary',
  newRequest: 'new-request',
  creationRoute: 'creation-route',
  consolidatedMaterials: 'consolidated-materials',
  consolidatedRecipe: 'consolidated-recipe',
  consolidatedVersion: 'consolidated-version',

  // Rutas para lo que es configuracion
  manufacturingRoutesConfiguration: 'configuration',
  typeMaterials: 'type-materials',
  measureUnits: 'measure-units',
  resources: 'resources',
  speedTrefilado: 'speed-trefilado',
  loadMaterial: 'load-material',
  speedVarilla: 'speed-varilla',
  speedPlastificado: 'speed-plastificado',
  speedAlambreGalvanizado: 'speed-alambre-galvanizado',

  //Rutas para el mantenedor de fichas
  manufacturingRoutesSkuSheet: 'sku-sheet',
  skuMallaOlimpica: 'malla-olimpica',
  skuMallaOlimpicaPlastificada: 'malla-olimpica-plastificada',
} as const;

export const AppRoutes = {
  home: `/${AppPaths.home}`,
  helpdesk: `/${AppPaths.helpdesk}`,
  expenseAccountability: `/${AppPaths.expenseAccountability}`,
  kronos: `${AppPaths.kronos}`,
  yourReceipt: `${AppPaths.yourReceipt}`,
  performanceAssessment: `${AppPaths.performanceAssessment}`,
  events: `/${AppPaths.events}`,
  loans: `/${AppPaths.loans}`,
  signUp: `/${AppPaths.signUp}`,
  login: `/${AppPaths.login}`,
  manageUser: `/${AppPaths.manageUser}`,
  approveTicket: `./${AppPaths.approveTicket}`,
  attendTicket: `./${AppPaths.attendTicket}`,
  createTicket: `./${AppPaths.createTicket}`,
  myTickets: `./${AppPaths.myTickets}`,
  contacts: `./${AppPaths.contacts}`,
  recordScheduledVisits: `/${AppPaths.recordScheduledVisits}`,
  scheduledVisits: `/${AppPaths.scheduledVisits}`,
  manufacturingRoutes: `/${AppPaths.manufacturingRoutes}`,
  requests: `./${AppPaths.requests}`,
  requestsSumary: `./${AppPaths.requestsSumary}`,
  newRequest: `./${AppPaths.newRequest}`,
  creationRoute: `./${AppPaths.creationRoute}`,
  consolidatedMaterials: `./${AppPaths.consolidatedMaterials}`,
  consolidatedRecipe: `./${AppPaths.consolidatedRecipe}`,
  consolidatedVersion: `./${AppPaths.consolidatedVersion}`,
  loadMaterial: `./${AppPaths.loadMaterial}`,

  get indicators() {
    return `./${AppPaths.indicators}`;
  },
  // Configuración de Rutas de Manufactura
  // Nota: Creamos la base primero para usarla en las constantes siguientes
  get manufacturingRoutesConfiguration() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.manufacturingRoutesConfiguration}`;
  },
  get typeMaterials() {
    return `${this.manufacturingRoutesConfiguration}/${AppPaths.typeMaterials}`;
  },
  get measureUnits() {
    return `${this.manufacturingRoutesConfiguration}/${AppPaths.measureUnits}`;
  },
  get resources() {
    return `${this.manufacturingRoutesConfiguration}/${AppPaths.resources}`;
  },
  get speedTrefilado() {
    return `${this.manufacturingRoutesConfiguration}/${AppPaths.speedTrefilado}`;
  },
  get speedVarilla() {
    return `${this.manufacturingRoutesConfiguration}/${AppPaths.speedVarilla}`;
  },
  get speedPlastificado() {
    return `${this.manufacturingRoutesConfiguration}/${AppPaths.speedPlastificado}`;
  },
  get speedAlambreGalvanizado() {
    return `${this.manufacturingRoutesConfiguration}/${AppPaths.speedAlambreGalvanizado}`;
  },

  //Ruta para el mantenedor de fichas
  get manufacturingRoutesSkuSheet() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.manufacturingRoutesSkuSheet}`;
  },
  get skuMallaOlimpica() {
    return `${this.manufacturingRoutesSkuSheet}/${AppPaths.skuMallaOlimpica}`;
  },
  get skuMallaOlimpicaPlastificada() {
    return `${this.manufacturingRoutesSkuSheet}/${AppPaths.skuMallaOlimpicaPlastificada}`;
  },
} as const;

export const RedirectRoutes = {
  // Help Desk
  get myTickets() {
    return `/${AppPaths.helpdesk}/${AppPaths.myTickets}`;
  },
  get createTicket() {
    return `/${AppPaths.helpdesk}/${AppPaths.createTicket}`;
  },

  // Manufacturing - Requests
  get myRequests() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.requests}`;
  },
  get newRequest() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.newRequest}`;
  },
  get creationRoute() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.creationRoute}`;
  },
  get myConsolidatedMaterials() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.consolidatedMaterials}`;
  },
  get myConsolidatedRecipe() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.consolidatedRecipe}`;
  },
  get myConsolidatedVersion() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.consolidatedVersion}`;
  },
  get myRequestsSumary() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.requestsSumary}`;
  },
  get myLoadMaterial() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.loadMaterial}`;
  },
  get myIndicators() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.indicators}`;
  },

  // Manufacturing - Configuration
  get myConfiguration() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.manufacturingRoutesConfiguration}`;
  },
  get myTypeMaterials() {
    return `${this.myConfiguration}/${AppPaths.typeMaterials}`;
  },
  get myResources() {
    return `${this.myConfiguration}/${AppPaths.resources}`;
  },
  get mySpeedTrefilado() {
    return `${this.myConfiguration}/${AppPaths.speedTrefilado}`;
  },
  get mySpeedVarilla() {
    return `${this.myConfiguration}/${AppPaths.speedVarilla}`;
  },
  get mySpeedPlastificado() {
    return `${this.myConfiguration}/${AppPaths.speedPlastificado}`;
  },
  get mySpeedAlambreGalvanizado() {
    return `${this.myConfiguration}/${AppPaths.speedAlambreGalvanizado}`;
  },

  // #region --- SECCIÓN SKU SHEETS ---

  get mySkuSheet() {
    return `/${AppPaths.manufacturingRoutes}/${AppPaths.manufacturingRoutesSkuSheet}`;
  },
  get mySkuMallaOlimpica() {
    return `${this.mySkuSheet}/${AppPaths.skuMallaOlimpica}`;
  },
  get mySkuMallaOlimpicaPlastificada() {
    return `${this.mySkuSheet}/${AppPaths.skuMallaOlimpicaPlastificada}`;
  },

  // #endregion
} as const;
